import { CheckCircle2, MailOpen } from "lucide-react";
import Navbar from "../../../components/layout/Navbar";
import { Link, useParams, useNavigate } from "react-router-dom";
import { Button } from "../../../components/Button";
import { useEffect } from "react";
import { useVerifyEmailMutation } from "../../../services/authApi";
import { toast } from "sonner";

const VerifySuccess = () => {
  const { key } = useParams();

  const navigate = useNavigate();

  const [verifyEmail, { isLoading, isSuccess, isError }] =
    useVerifyEmailMutation();

  useEffect(() => {
    if (key) {
      const verify = async () => {
        const { data } = await verifyEmail(key);
        if (data.detail == "ok") {
          localStorage.removeItem("verify-email");
          toast.success("Email verified successfully");
          setTimeout(() => {
            navigate("/login");
          }, 2000);
        }
      };
      verify();
    }
  }, [key, verifyEmail]);

  return (
    <div>
      <Navbar />
      <div className="p-5 sm:p-14 h-[81vh] flex items-start md:items-center justify-center landing-bg bg-cover bg-no-repeat bg-center">
        <div className="w-full md:w-fit flex items-center justify-center flex-col bg-white">
          <div className=" sm:p-10 rounded-2xl sm:border border-[#7E57C233]  w-[100%] sm:w-[80%] md:w-fit flex items-center justify-between gap-20 ">
            <div className="flex flex-col gap-6 items-center justify-start w-[500px]">
              <div className=" flex items-center justify-center gap-2 relative">
                {" "}
                <MailOpen size={150} strokeWidth={0.2} color="#E5E5E5" />{" "}
                <CheckCircle2
                  className="absolute bottom-0 right-0 fill-white"
                  strokeWidth={2}
                  color="#7AC455"
                />
              </div>
              <div className="flex flex-col items-center justify-center gap-6 w-full">
                {isLoading && <p>Verifying your email...</p>}
                {isSuccess && (
                  <>
                    <h3 className="flex items-center justify-start font-medium">
                      Email Verification Successful
                    </h3>
                    <span className="text-center text-[#A3A3A3]">
                      You'll be redirected automatically in 4 seconds, if not,
                      you can use the button below.
                    </span>
                    <Button text="Proceed" className="sm:w-fit w-full" />
                  </>
                )}
                {isError && (
                  <p className="text-red-500">
                    Verification failed. Please try again.
                  </p>
                )}
                <span className="text-center text-[#A3A3A3]">
                  If you haven’t performed this action, kindly ignore this email
                  and write us to support@jellosite.com
                  <a
                    href="mailto:support@jellosite.com"
                    className="text-[#945bf5]"
                  >
                    {" "}
                    support@jellosite.com
                  </a>
                </span>
              </div>
            </div>
          </div>
          <ul className="text-[#666666] md:w-full hidden sm:flex gap-3.5 sm:w-[80%]  items-center justify-end mt-1 ">
            <Link to="">
              <li>Help</li>
            </Link>
            <Link to="">
              <li>Privacy</li>
            </Link>
            <Link to="">
              <li>Terms</li>
            </Link>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default VerifySuccess;
